const customerDetails = (state = null, action) => {
  if (action.type === "SET_CUSTOMER_DETAILS") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CUSTOMER_DETAILS": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default customerDetails;
